import { useEffect } from "react";
import ReactMarkdown from "react-markdown";
import { useQuery } from "react-query";
import styled from "styled-components";
import { getOnePageItem } from "../api/api";
import { ImagesEntity, IInnerPage } from "../types/inner_page";
import Loader from "react-loader-spinner";
import {
  GLOBAL_MEDIA_QUERIES,
  primaryColors,
  secondaryColors,
} from "../constatnts";
import { useTranslation } from "react-i18next";
import { useMedia } from "react-media";
import { IMedia } from "../types/types";
import InnerPageLayout from "../Components/Layout/InnerPageLayout";
import { useParams } from "react-router-dom";

interface IProps {
  id?: string;
}
const InnerPage = (props: IProps) => {
  const matches = useMedia({ queries: GLOBAL_MEDIA_QUERIES });
  let { id } = useParams();

  const { i18n } = useTranslation();

  const { isLoading, error, data, refetch }: any = useQuery(
    `innerPageData-${id}`,
    () => getOnePageItem({ id: id || "1", language: i18n.language }),
  );

  useEffect(() => {
    refetch();
  }, [i18n.language]);

  if (isLoading)
    return (
      <InnerPageLayout>
        <LoaderContainer>
          <Loader
            type="Puff"
            color="#ffffff"
            height={70}
            width={70}
            timeout={3000} //3 secs
          />
        </LoaderContainer>
      </InnerPageLayout>
    );

  if (error)
    return (
      <InnerPageLayout>
        <div></div>
      </InnerPageLayout>
    );

  let pageItem: IInnerPage = data["data"];
  const resources = [
    {
      title: "الملف التعريفي",
      url: "https://ttconline-my.sharepoint.com/personal/rfawzan_rafedsa_com/_layouts/15/onedrive.aspx?csf=1&web=1&e=SVTp30&ovuser=f825d291%2Dacbd%2D4d5b%2Da689%2D76361157b44c%2CMAwad%40rafedsa%2Ecom&OR=Teams%2DHL&CT=1779027205851&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiI1MC8yNjA0MDQwMTcyMyIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3D%3D&CID=5b8714a2%2Db09b%2D1001%2D51a8%2Dba8b1ee8c786&cidOR=SPO&id=%2Fpersonal%2Frfawzan%5Frafedsa%5Fcom%2FDocuments%2F%D8%A7%D9%84%D9%87%D9%88%D9%8A%D8%A9%20%D8%A7%D9%84%D8%A8%D8%B5%D8%B1%D9%8A%D8%A9%20%D9%84%D8%B4%D8%B1%D9%83%D8%A9%20%D8%B1%D8%A7%D9%81%D8%AF%2F%D8%A7%D9%84%D8%B9%D8%B1%D8%B6%20%D8%A7%D9%84%D8%AA%D8%B9%D8%B1%D9%8A%D9%81%D9%8A%20%D9%84%D9%84%D8%B4%D8%B1%D9%83%D8%A9&FolderCTID=0x01200053EFB27ECEDB284299561CAED2EC2780&view=0",
    },
    {
      title: "التقارير السنوية",
      url: "https://ttconline-my.sharepoint.com/personal/aobaid_rafedsa_com/_layouts/15/onedrive.aspx?id=%2Fpersonal%2Faobaid%5Frafedsa%5Fcom%2FDocuments%2FDesktop%2F%D9%85%D9%84%D9%81%D8%A7%D8%AA%20%D8%A5%D8%AF%D8%A7%D8%B1%D8%A9%20%D8%A7%D9%84%D8%A7%D8%AA%D8%B5%D8%A7%D9%84%20%D8%A7%D9%84%D9%85%D8%A4%D8%B3%D8%B3%D9%8A%20%D8%A7%D9%84%D9%85%D8%A4%D8%B1%D8%B4%D9%81%D8%A9%2F%D9%85%D9%84%D9%81%D8%A7%D8%AA%20%D8%A7%D9%84%D8%A5%D8%AF%D8%A7%D8%B1%D8%A9%202026%D9%85%2FFaisal%20Files%20%2D%20digital%20date%20%26%20social%20medai%2Fdownloads%2F%D8%A7%D9%84%D8%AA%D9%82%D8%A7%D8%B1%D9%8A%D8%B1%20%D8%A7%D9%84%D8%B3%D9%86%D9%88%D9%8A%D8%A9%2FOneDrive%5F1%5F1%2D5%2D2026%2Ezip%20%2D%20%D8%A7%D9%84%D8%AA%D9%82%D8%A7%D8%B1%D9%8A%D8%B1%20%D8%A7%D9%84%D8%B3%D9%86%D9%88%D9%8A%D8%A9&ct=1779027261365&or=Teams%2DHL&ga=1&LOF=1",
    },
    {
      title: "نماذج العروض",
      url: "https://ttconline-my.sharepoint.com/personal/rfawzan_rafedsa_com/_layouts/15/onedrive.aspx?csf=1&web=1&e=c8oR7G&ovuser=f825d291%2Dacbd%2D4d5b%2Da689%2D76361157b44c%2CMAwad%40rafedsa%2Ecom&OR=Teams%2DHL&CT=1779027283067&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiI1MC8yNjA0MDQwMTcyMyIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3D%3D&CID=6e8714a2%2D5063%2D1001%2D3926%2D7ab71de816e6&cidOR=SPO&id=%2Fpersonal%2Frfawzan%5Frafedsa%5Fcom%2FDocuments%2F%D8%A7%D9%84%D9%87%D9%88%D9%8A%D8%A9%20%D8%A7%D9%84%D8%A8%D8%B5%D8%B1%D9%8A%D8%A9%20%D9%84%D8%B4%D8%B1%D9%83%D8%A9%20%D8%B1%D8%A7%D9%81%D8%AF%2F%D8%B9%D8%B1%D9%88%D8%B6%20%D8%AA%D9%82%D8%AF%D9%8A%D9%85%D9%8A%D8%A9&FolderCTID=0x01200053EFB27ECEDB284299561CAED2EC2780&view=0",
    },
    {
      title: "الفيديوهات",
      url: "https://ttconline-my.sharepoint.com/personal/rfawzan_rafedsa_com/_layouts/15/onedrive.aspx?csf=1&web=1&e=hquZAJ&ovuser=f825d291-acbd-4d5b-a689-76361157b44c%2cMAwad%40rafedsa.com&OR=Teams-HL&CT=1779027307887&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiI1MC8yNjA0MDQwMTcyMyIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3d%3d&CID=748714a2-9070-1001-3926-7afa7672d644&cidOR=SPO&id=%2fpersonal%2frfawzan_rafedsa_com%2fDocuments%2f%D8%A7%D9%84%D9%87%D9%88%D9%8A%D8%A9+%D8%A7%D9%84%D8%A8%D8%B5%D8%B1%D9%8A%D8%A9+%D9%84%D8%B4%D8%B1%D9%83%D8%A9+%D8%B1%D8%A7%D9%81%D8%AF%2f%D9%81%D9%8A%D8%AF%D9%8A%D9%88%D9%87%D8%A7%D8%AA&FolderCTID=0x01200053EFB27ECEDB284299561CAED2EC2780&view=0",
    },
    {
      title: "الصور",
      url: "https://ttconline-my.sharepoint.com/personal/rfawzan_rafedsa_com/_layouts/15/onedrive.aspx?csf=1&web=1&e=Deh92i&ovuser=f825d291%2Dacbd%2D4d5b%2Da689%2D76361157b44c%2CMAwad%40rafedsa%2Ecom&OR=Teams%2DHL&CT=1779027325590&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiI1MC8yNjA0MDQwMTcyMyIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3D%3D&CID=788714a2%2D30c6%2D1001%2D3926%2D7999ea4b5a23&cidOR=SPO&id=%2Fpersonal%2Frfawzan%5Frafedsa%5Fcom%2FDocuments%2F%D8%A7%D9%84%D9%87%D9%88%D9%8A%D8%A9%20%D8%A7%D9%84%D8%A8%D8%B5%D8%B1%D9%8A%D8%A9%20%D9%84%D8%B4%D8%B1%D9%83%D8%A9%20%D8%B1%D8%A7%D9%81%D8%AF%2F%D8%B5%D9%88%D8%B1%20%D9%84%D9%84%D8%A7%D8%B3%D8%AA%D8%AE%D8%AF%D8%A7%D9%85&FolderCTID=0x01200053EFB27ECEDB284299561CAED2EC2780&view=0",
    },
    {
      title: "هوية شركة رافد",
      url: "https://ttconline-my.sharepoint.com/personal/rfawzan_rafedsa_com/_layouts/15/onedrive.aspx?csf=1&web=1&e=DwhEzF&ovuser=f825d291%2Dacbd%2D4d5b%2Da689%2D76361157b44c%2CMAwad%40rafedsa%2Ecom&OR=Teams%2DHL&CT=1779027345829&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiI1MC8yNjA0MDQwMTcyMyIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3D%3D&CID=7d8714a2%2Dd0b2%2D1001%2D3926%2D7de7ee056c0f&cidOR=SPO&id=%2Fpersonal%2Frfawzan%5Frafedsa%5Fcom%2FDocuments%2F%D8%A7%D9%84%D9%87%D9%88%D9%8A%D8%A9%20%D8%A7%D9%84%D8%A8%D8%B5%D8%B1%D9%8A%D8%A9%20%D9%84%D8%B4%D8%B1%D9%83%D8%A9%20%D8%B1%D8%A7%D9%81%D8%AF%2F%D8%A7%D9%84%D8%AF%D9%84%D9%8A%D9%84%20%D8%A7%D9%84%D8%A7%D9%95%D8%B1%D8%B4%D8%A7%D8%AF%D9%8A&FolderCTID=0x01200053EFB27ECEDB284299561CAED2EC2780&view=0",
    },
    {
      title: "هوية شركة تطوير التعليم القابضة",
      url: "https://ttconline-my.sharepoint.com/personal/rfawzan_rafedsa_com/_layouts/15/onedrive.aspx?id=%2Fpersonal%2Frfawzan%5Frafedsa%5Fcom%2FDocuments%2F%D8%A7%D9%84%D9%87%D9%88%D9%8A%D8%A9%20%D8%A7%D9%84%D8%A8%D8%B5%D8%B1%D9%8A%D8%A9%20%D9%84%D8%B4%D8%B1%D9%83%D8%A9%20%D8%B1%D8%A7%D9%81%D8%AF&ct=1779027364766&or=Teams%2DHL&ga=1&LOF=1",
    },
  ];

  return (
    <InnerPageLayout>
      <Container {...matches}>
        <Content>
          <h4 className="shape-round mb-lg-5 pb-5">{pageItem.title}</h4>

          <ReactMarkdown>{pageItem.content}</ReactMarkdown>
          {/* <Spacer /> */}
          {/* Enhanced Links UI */}
          {pageItem.id === 17 && (
            <div className="resources-box">
              <ul className="resource-list">
                {resources.map((item, index) => (
                  <li key={index} className="resource-item">
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="resource-link"
                    >
                      {item.title}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </Content>
          <Spacer />

        <ImagesContainer>
          {pageItem.images.map((image: ImagesEntity, index: number) => (
            <Image
              key={image?.url || index}
              src={`${process.env.REACT_APP_CMS}${image?.url}`}
              {...matches}
            />
          ))}
        </ImagesContainer>
      </Container>
    </InnerPageLayout>
  );
  //   return (
  //     <InnerPageLayout>
  //       <>
  //         <Container  {...matches}>
  //           <Content>
  //           <h4 className="shape-round mb-lg-5 pb-5">{pageItem.title}</h4>

  //             <ReactMarkdown>{pageItem.content}</ReactMarkdown> <Spacer />
  //           </Content>
  //           <ImagesContainer>
  //             {pageItem.images.map((image: ImagesEntity) => (
  //               <Image src={`${process.env.REACT_APP_CMS}${image?.url}`}  {...matches} />
  //             ))}
  //           </ImagesContainer>
  // {pageItem.id}

  //         </Container>{" "}
  //       </>
  //     </InnerPageLayout>
  //   );
};

const TitleImage = styled.img`
  position: absolute;
  width: 80px;
  top: 0;
  z-index: -1;
  right: -10px;
`;

const Container = styled.div<IMedia>`
  padding: ${(props) => (props.large ? "30px 70px" : "10px 10px")};
  flex-direction: ${(props) => (props.large ? "row" : "column-reverse")};
  display: flex;
  position: relative;
`;

const Content = styled.div`
  padding: 10px 30px;
  line-height: 1.5em;
  position: relative;
  flex: 1;
  color: ${primaryColors[3]};
  margin: 10px;
`;

const ImagesContainer = styled.div``;
const Title = styled.h1`
  color: ${primaryColors[0]};
`;
const SubTitle = styled.h4`
  color: ${secondaryColors[0]};
`;

const Spacer = styled.div`
  height: 30px;
  width: 30px;
`;

const Image = styled.img<IMedia>`
  width: ${(props) => (props.large ? "45vw" : "100vw")};
  box-shadow: 20px 19px 0 0 rgb(189 189 189 / 50%);
  object-fit: contain;
  height: 500px;
`;
const LoaderContainer = styled.div`
  min-height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export default InnerPage;
